import React from 'react';
import {connect} from 'react-redux';
import {submit, isSubmitting} from 'redux-form';

import Button from 'components/Button';
import {default as Modal, withModal} from 'components/Modal';

import {ExtraAction} from 'ducks/types';
import {fetchXeroAccounts} from 'ducks/tenancy';
import {MODALS} from 'ducks/oneOffChargeReasons';

import {CreateOneOffChargeReasonForm} from './components';

import './styles.css';

const Buttons = ({triggerSubmit, submitting, onClose}) => (
  <div className="colab-row-space-between">
    <Button onClick={onClose} transparent white className="cancel">
      Cancel
    </Button>
    <Button
      onClick={triggerSubmit}
      className="submit"
      blue={!submitting}
      disabled={submitting}
      loading={submitting}>
      Create
    </Button>
  </div>
);

interface CreateOneOffChargeReasonModalProps {
  closeModal: () => void;
  locationRef: string;
  storeDataExtraActions: (data) => ExtraAction[];
  data: any;
}

class CreateOneOffChargeReasonModal extends React.Component<
  CreateOneOffChargeReasonModalProps &
    ReturnType<typeof mapStateToProps> &
    typeof mapDispatchToProps
> {
  componentDidMount() {
    const {locationRef} = this.props;

    this.props.fetchXeroAccounts(
      {location: locationRef},
      this.props.storeDataExtraActions(data => ({
        xeroAccounts: data
      }))
    );
  }

  triggerFormSubmit = () => {
    this.props.submit('createOneOffChargeReason');
  };

  render() {
    const {form: {submitting}, data: {xeroAccounts}} = this.props;

    return (
      <Modal
        show={true}
        onClose={this.props.closeModal}
        className="CreateOneOffChargeReasonModal"
        type={Modal.EXTRA_SMALL}>
        <Modal.Header heading="Create charge reason " />
        <Modal.Body>
          <CreateOneOffChargeReasonForm
            locationRef={this.props.locationRef}
            xeroAccounts={xeroAccounts || []}
          />
        </Modal.Body>
        <Modal.Footer>
          <Buttons
            triggerSubmit={this.triggerFormSubmit}
            submitting={submitting}
            onClose={this.props.closeModal}
          />
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = state => {
  return {
    form: {
      submitting: isSubmitting('createOneOffChargeReason')(state)
    }
  };
};

const mapDispatchToProps = {
  submit,
  fetchXeroAccounts
};

export default connect(mapStateToProps, mapDispatchToProps)(withModal(
  MODALS.CREATE_ONE_OFF_CHARGE_REASON
)(CreateOneOffChargeReasonModal) as React.ComponentType<any>);
